import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ContractService } from 'src/app/contract/shared/contract.service';

@Component({
  selector: 'app-contract-history',
  templateUrl: './contract-history.component.html',
  styleUrl: './contract-history.component.css'
})
export class ContractHistoryComponent implements OnInit, AfterViewInit {
  dataLoading: boolean = true;
  @Input() contractId;
  auditSource = new MatTableDataSource<any>();
  versionSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  downloadLoading: { [key: string]: boolean } = {};
  auditColumns: string[] = ['Action','Time'];
  versionColumns: string[] = ['Version', 'Created By', 'Created Date', 'Action'];

  constructor(private contractService: ContractService, private toast: ToastrService){
    this.auditSource.data = null;
    this.versionSource.data = null;
  }

  ngOnInit(): void {
    this.getLogs();
    this.getVersions();
  }

  // Method to refresh both logs and versions - useful for external calls
  refreshHistory(): void {
    this.dataLoading = true;
    this.getLogs();
    this.getVersions();
  }

  ngAfterViewInit(): void {
    this.auditSource.paginator = this.paginator;
    this.auditSource.sort = this.sort;
    this.versionSource.paginator = this.paginator;
    this.auditSource.sort = this.sort
  }

  downloadDocument(id) {
    this.downloadLoading[id] = true;
    this.contractService.downloadPDF(id);

    setTimeout(() => {
      this.downloadLoading[id] = false;
      this.toast.success('Document Downloaded Sucessfully!', '');
    }, 2000);
  }

  async getLogs() {
    try {
      await this.contractService.getAuditLogs(this.contractId).then((res: any) => {
        res.forEach((log: any) => {
          log.createdDate = moment(log.createdDate).format('lll');
        });
        this.auditSource.data = res;
      })
    } catch (error) {
      this.toast.error('Something went wrong! Please try again later.', '');
    }
    this.dataLoading = false;
  }

  async getVersions() {
    try {
      await this.contractService.getVersions(this.contractId).then((res: any) => {
        res.forEach((log: any) => {
          log.createdDate = moment(log.createdDate).format('lll');
        });
        this.versionSource.data = res;
      })
    } catch (error) {
      this.toast.error('Something went wrong! Please try again later.', '');
    }
    this.dataLoading = false;
  }

  customSortData(event: Sort) {
    const data = this.auditSource.data.slice();
    if (!event.active || event.direction === '') {
      this.auditSource.data = data;
      return;
    }

    this.auditSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
